/**
 * @generated SignedSource<<ce6a8bce73876f32a04d2f7fd2550f0b>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0

import type { ConcreteRequest } from 'relay-runtime';
export type useIsLoomEntryPointsEnabledQuery$variables = {
  cloudId: string;
};
export type useIsLoomEntryPointsEnabledQuery$data = {
  readonly confluence_loomEntryPoints: {
    readonly isLoomEntryPointsEnabled: boolean;
  } | null | undefined;
};
export type useIsLoomEntryPointsEnabledQuery = {
  response: useIsLoomEntryPointsEnabledQuery$data;
  variables: useIsLoomEntryPointsEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceLoomEntryPoints",
    "kind": "LinkedField",
    "name": "confluence_loomEntryPoints",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isLoomEntryPointsEnabled"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsLoomEntryPointsEnabledQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsLoomEntryPointsEnabledQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
    "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
    "metadata": {},
    "name": "useIsLoomEntryPointsEnabledQuery",
    "operationKind": "query",
    "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
  }
};
})();

(node as any).hash = "767e6480b08dd1cf6643fe7ca065c357";

export default node;
